const cate = {
  "causal-cate-title": "CATE(条件付き平均処置効果)",
  "causal-cate-outcome-node-label": "解析対象とするノードを設定：",
  "causal-cate-outcome-node": "アウトカムノード",
  "causal-cate-treatment-node-label": "処置(介入)対象とするノードを設定：",
  "causal-cate-treatment-node": "処置ノード",
  "causal-cate-outcome-distribution": "アウトカムノードの分布",
  "causal-cate-treatment-distribution": "処置ノードの分布",
  "causal-cate-treatment-histogram": "処置ノードのヒストグラム",
  "causal-histogram-outlier-count": "(外れ値数：{{num}})",
  // CATE結果チャートの X軸ラベル（アウトカム名 + のCATE + unit）
  "causal-cate-effect-axis-with-unit": "{{name}}のCATE ({{unit}})",
  "causal-cate-effect-axis-no-unit": "{{name}}のCATE",
  // レベル毎（層別）チャートの上部タイトル
  "causal-cate-ite-level-distribution": "{{name}}レベル毎の処置効果の分布",
  "causal-cate-population-percentage-label": "識別コード比率",
  "causal-cate-time-lag": "時差（ラグ）",
  "causal-cate-check-nodes-label": "ノード決定",
  "causal-cate-calculate-button": "CATE計算",
  "causal-cate-model-list-button": "モデル一覧",
  "causal-cate-load-graph-button": "既存グラフ読み込み",
  "causal-cate-graph-list-title": "グラフ選択",
  "causal-cate-graph-name-label": "グラフ名",
  "causal-cate-modifier-factors": "共変量",
  "causal-cate-result-title": "CATE解析結果",
  "causal-cate-calculation-result": "CATE計算結果",
  "causal-cate-ite-options": "ITEオプション",
  "causal-cate-model-id": "モデルID",
  "causal-cate-outcome": "アウトカム",
  "causal-cate-treatment": "処置",
  "causal-cate-covariates": "共変量",
  "causal-cate-available-options": "利用可能なオプション",
  "causal-cate-no-data": "データがありません",
  "causal-cate-no-data-description": "CATE計算を実行すると結果がここに表示されます",
  "causal-cate-edit-name-button": "名前を編集",
  "causal-cate-enter-name-label": "名前を入力してください",
  "causal-cate-save-graph-button": "保存",
  "causal-cate-id-code-selection": "識別コード選択",
  "causal-cate-date-selection": "日付選択",
  "causal-cate-analysis-title": "CATE計算結果",
  "causal-cate-history-error": "履歴の読み込みに失敗しました",
  "causal-cate-no-history": "モデル履歴がありません",
  "causal-cate-model-name-label": "モデル名",
  "causal-cate-list-create-date": "作成日",
  "causal-cate-confirm-button": "確定",
  "causal-cate-cancel-button": "キャンセル",
  "causal-cate-rename": "名前を変更する",
  "causal-cate-delete": "削除する",

  "strat-node": "層別化変数",

  // Toast messages
  "causal-cate-toast-delete-success": "モデルを削除しました",
  "causal-cate-toast-delete-error": "モデルの削除に失敗しました",

  // Effect Prediction
  "causal-cate-effect-prediction": "効果予測",
  "causal-cate-predict-button": "予測",
  "causal-cate-estimated-effect": "推定効果",
  "causal-cate-prediction-success": "予測が完了しました",
  "causal-cate-prediction-error": "効果の予測に失敗しました",
  "causal-cate-no-model-error": "予測に使用可能なモデルがありません",
  "causal-cate-no-covariates": "このユーザーに利用可能な共変量がありません",

  // Conditional Effect Calculation
  "calculating": "計算中...",
  "calculate-conditional-effect": "効果を計算",
  "error-noModelSelected": "モデルが選択されていません",
  "error-noUserSelected": "ユーザーが選択されていません",
  "success-calculated": "計算が完了しました",
  "error-calculationFailed": "計算に失敗しました",
  "cate-value-label": "条件付き処置効果",
  "cate-value-near-zero-warning": "この値はゼロに近く、正確に計算されていない可能性があります。",
  "causal-cate-average-label": "平均",
  "causal-cate-legend-label": "処置効果の分布",
  "causal-cate-no-treatment-nodes": "このアウトカムには有効な処置ノードがありません。\n処置ノードを変更するか、モデルを変更してください。",
  "causal-cate-ok-button": "OK",

  // Edit mode
  "edit": "編集",
  "reset": "リセット",
  "search-id-codes": "識別コードを検索",

  // 処置変数の二値化（Binarize Treatment）
  "cate-binarize-button": "二値化設定",
  "cate-binarize-cancel": "二値化のキャンセル",
  "cate-binarize-panel-title": "二値化設定",
  "cate-binarize-threshold": "閾値",
  "cate-binarize-level0": "レベル0",
  "cate-binarize-level1": "レベル1",
  "cate-binarize-sample-count": "サンプル数",
  "cate-binarize-min-samples": "全ての離散化レベルのサンプル数は10以上である必要があります。",
  "cate-binarize-confirm": "決定",
  "cate-binarize-no-data": "データのある範囲で閾値を選択してください",

};

export default cate;